import { computed } from "vue";

// Canonical CSS custom-property namespace for the tenant's brand palette.
// Bound once at the page root so every descendant can read var(--brand-*)
// directly instead of re-deriving its own locally-named alias.
export function useBrandCssVars(colorsRef) {
    return computed(() => ({
        "--brand-primary": colorsRef.value?.primary,
        "--brand-accent": colorsRef.value?.accent,
        "--brand-accent-dark": colorsRef.value?.accentDark,
        "--brand-accent-light": colorsRef.value?.accentLight,
        "--brand-dark": colorsRef.value?.dark,
        "--brand-darkest": colorsRef.value?.darkest,
        "--brand-light": colorsRef.value?.light,
        "--brand-lightest": colorsRef.value?.lightest,
        "--brand-white": colorsRef.value?.white,
        "--brand-whitest": colorsRef.value?.whitest,
        "--brand-text-primary": colorsRef.value?.textPrimary,
        "--brand-text-secondary": colorsRef.value?.textSecondary,
        "--brand-text-tertiary": colorsRef.value?.textTertiary,
    }));
}
